<template>
  <div class="login-demo">
    <div class="login-wrap">
      <div class="login-left" >
        <img src="@/assets/imgs/login-left.png" alt="">
      </div>
      <div class="login-right">
          <!-- 登录框 -->
        <el-form ref="loginForm" :rules="formRules" :model="user" status-icon label-width="130px">
            <div class="title">用 户 注 册</div>
            <!-- 注册框 -->
              <el-form-item prop="role" label="用户类型">
                <el-select style="width: 282px;" v-model="user.role" placeholder="请选择">
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="user.role === 7" prop="code" label="邀请码">
                <el-input v-model="user.code" placeholder="请输入邀请码" clearable></el-input>
              </el-form-item>
              <el-form-item v-if="user.role === 7" prop="companyName" label="企业名称">
                <el-input v-model="user.companyName" placeholder="请输入企业名称" clearable></el-input>
              </el-form-item>
              <el-form-item prop="name" width="100px;" :label="user.role === 7 ? '企业负责人/法人' : '姓名'">
                <el-input v-model="user.name" :placeholder="user.role === 7 ? '请输入企业负责人/法人' : '请输入姓名'" clearable></el-input>
              </el-form-item>
              <el-form-item prop="qq" label="QQ">
                <el-input v-model="user.qq" placeholder="请输入QQ" clearable></el-input>
              </el-form-item>
              <el-form-item prop="wechat" label="微信号">
                <el-input v-model="user.wechat" placeholder="请输入微信号" clearable></el-input>
              </el-form-item>
              <el-form-item prop="phone" label="手机">
                <template v-if="user.role === 6">
                  <el-input v-model="user.phone"  placeholder="请输入手机号" clearable></el-input>
                </template>
                <template v-else-if="user.role === 7">
                  <el-input v-model="user.phone"  placeholder="请输入手机号" clearable></el-input>
<!--                  <el-button size="medium" v-if="user.role === 7" type="primary" plain @click="sendCode" :disabled="isSending || countdown > 0 || !user.code || !user.phone">-->
<!--                    {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : '发送验证码' }}-->
<!--                  </el-button>-->
                </template>

              </el-form-item>
<!--          <el-form-item v-if="user.role === 7" prop="verificationCode" label="验证码">-->
<!--            <el-input v-model="user.verificationCode" placeholder="请输入验证码" clearable></el-input>-->
<!--          </el-form-item>-->
              <el-form-item prop="password" label="密码">
                <el-input v-model="user.password" show-password placeholder="请输入密码" clearable></el-input>
              </el-form-item>
              <el-form-item prop="password2" label="密码确认">
                <el-input v-model="user.password2" show-password placeholder="请再次输入密码" clearable></el-input>
              </el-form-item>
              <div v-if="user.role === 7" style="color: blue;cursor: pointer;" @click="readAgreement">
<!--                <span style="color: #409EFF;">请点击阅读</span>-->
                <el-checkbox @change="checkboxChange" prop="checked" v-model="user.checked">我已阅读并同意</el-checkbox>
                <span>《线上VIP会员服务购买协议》</span>
              </div>
              <el-form-item style="margin-top: 10px;" class="register-button">
                <el-button class="submit-button" type="warning" @click="back">返回登录</el-button>
                <el-button class="submit-button" type="primary" @click="doRegister('loginForm')">提交注册</el-button>
              </el-form-item>
        </el-form>
<!--        <div v-html="import('/public/file/agreement.html')"></div>-->
<!--        <iframe  src="/file/agreement.html"-->
<!--                 style="z-index: 1000; height:650px; width: 100%; margin: 0 auto"-->
<!--                 sandbox="allow-scripts allow-top-navigation allow-same-origin allow-popups"-->
<!--        ></iframe>-->
        <el-dialog
          :visible.sync="dialogVisible"
          width="80%"
          :show-close="false"
        >
          <div style="height: 450px;overflow: auto;margin-bottom: 10px;" v-html="htmlData"></div>
          <div style="position: sticky;bottom: 10px;background-color: #fff;">
            <div style="text-align: left">
              <el-checkbox  prop="checked" v-model="checked">已详阅并同意</el-checkbox>
            </div>
            <div style="text-align: right">
              <el-button type="primary" @click="signContract">确认并签订协议</el-button>
            </div>
          </div>
<!--          <span slot="footer" class="dialog-footer">-->
<!--            <el-button @click="dialogVisible = false">关 闭</el-button>-->
<!--          </span>-->
        </el-dialog>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: "Login",
  data() {
    return {
      activeName: "login",
      checked: false,
      user: {
        name: "",
        companyName: '',
        qq: "",
        wechat: "",
        phone: "",
        password: "",
        password2: "",
        role: 7,
        checked: false,
        code: '',
        verificationCode: '',
      },
      roleOptions: [{
        value: 7,
        label: '企业用户'
      }, {
        value: 6,
        label: '设计师'
      }],
      // 通过 formRules 属性传入约定的验证规则
      formRules: {
        name: [{ required: true, message: "用户名不能为空", trigger: "blur" },
                  /*  { type: "string", min: 2, message: "账号不能小于2位", trigger: "blur" },
                  { type: "string", max: 20, message: "账号不能大于20位", trigger: "blur" },*/
                  {pattern: /^[_0-9a-zA-Z\u4E00-\u9FA5]+$/, message: '账号只能为中文、数字、字母、下划线', trigger: 'blur'}
        ],
        companyName: [{ required: true, message: "企业名称不能为空", trigger: "blur" },
          /*  { type: "string", min: 2, message: "账号不能小于2位", trigger: "blur" },
          { type: "string", max: 20, message: "账号不能大于20位", trigger: "blur" },*/
          {pattern: /^[_0-9a-zA-Z\u4E00-\u9FA5]+$/, message: '企业名称只能为中文、数字、字母、下划线', trigger: 'blur'}
        ],
        code: [{ required: true, message: "邀请码不能为空", trigger: "blur" },
        ],
        // verificationCode: [{ required: true, message: "验证码不能为空", trigger: "blur" },
        // ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          /*  { type: "string", min: 6, message: "密码不能小于6位", trigger: "blur" },
            { type: "string", max: 20, message: "密码不能大于20位", trigger: "blur" },*/
          // {pattern: /^[_0-9a-zA-Z]+$/, message: '账号只能为中文、数字、字母、下划线', trigger: 'blur'}
        ],
        password2: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        qq: [{pattern: /^[0-9]+$/, message: 'qq号只能为数字', trigger: 'blur'}],
        wechat: [{pattern: /^[_0-9a-zA-Z]+$/, message: '微信号只能为数字、字母、下划线', trigger: 'blur'}],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {pattern: /^[0-9]+$/, message: '手机号只能为数字', trigger: 'blur'}],
        // bug--由于此处登录和注册共用一个el-form，因此只能绑定一个rules,如果邮箱设置为必填，将导致无法登陆。一般情况下，将登录和注册分别放在不同的el-form中，为它们设置不同的rules

      },
      isSending: false,
      countdown: 0,
      dialogVisible: false,
      htmlData: null,
      readFlag: false
    }
  },
  created() {
    this.$http.get(`${location.origin}/file/agreement.html`, {}, {})
      .then(res => {
        this.htmlData = res.data;
      });
  },
  methods: {
    signContract(){
      if(!this.checked){
        this.$message.error('请详阅并同意协议');
        return
      }
      this.dialogVisible = false;
      this.user.checked = true;
    },
    checkboxChange(val){
      if(val && !this.readFlag){
        this.readAgreement();
      }
    },
    readAgreement(){
      this.readFlag = true;
      this.dialogVisible = true;
    },
    sendCode() {
      if (this.countdown > 0 || this.isSending) {
        return; // 防止重复点击发送
      }
      this.isSending = true;
      this.startCountdown();
      this.sendVerificationCode();
    },
    startCountdown() {
      this.countdown = 10;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    sendVerificationCode(){
      this.$http.post(`/user/verificationCode?code=${this.user.code}`, {}, { headers: {
          token: window.sessionStorage.manageToken
        }})
        .then(res => {
          console.log('res====',res)
          if (res.data.code === 'ok') {
            this.sendPhoneMessage();
          } else {
            this.$message.error(res.data.data)
            this.isSending = false;
            this.countdown = 0;
          }
        });
    },
    sendPhoneMessage(){
      this.$http.post(`/user/sendPhoneMessage?phone=${this.user.phone}`, {}, { headers: {
          token: window.sessionStorage.manageToken
        }})
        .then(res => {
          console.log('res====',res)
          if (res.data.code === 'ok') {
            this.isSending = false;
          } else {
            this.$message.error(res.data.data)
            this.isSending = false;
            this.countdown = 0;
          }
        });
    },
    open() {
      // this.$confirm('我已阅读并同意《注册版合同》, 是否继续?', '提示', {
      //   confirmButtonText: '同意并继续',
      //   cancelButtonText: '不同意',
      //   type: 'warning'
      // }).then(() => {
      //   // this.$message({
      //   //   type: 'success',
      //   //   message: '删除成功!'
      //   // });
      //   this.user.checked = true;
      // }).catch(() => {
      //   // this.$message({
      //   //   type: 'info',
      //   //   message: '已取消删除'
      //   // });
      // });
        this.$message({
          type: 'error',
          message: '请详阅并同意协议'
        });
    },
    // 注册账号
    doRegister(form) {
      if(this.user.role === 7 && !this.user.checked){
        this.open();
        return
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log(valid);
          console.log('校验通过==')
          if(this.user.password !== this.user.password2){
            this.$message.error('两次输入的密码不一致');
            this.user.password = '';
            this.user.password2 = '';
            return;
          }
          const data = {
            name: this.user.name,
            password: this.user.password,
            qq: this.user.qq,
            phone: this.user.phone,
            wechat: this.user.wechat,
            role: this.user.role,
          }
          if(this.user.role === 7){
            data.companyName = this.user.companyName;
            data.verificationCode = this.user.code;
          }
          this.$http.post("/user/register", data )
            .then(res => {
              console.log('res====',res)
              console.log('resdata====',res.data)
              //  console.log("输出response.data", res.data);
              if (res.data.code === 'ok') {
                console.log('resdatadata====',res.data.data)
                this.$message({
                  message: '注册成功',
                  type: 'success',
                  duration: 800
                });
                // this.$message.success('注册成功',100)
                window.sessionStorage.name = this.user.phone;
                setTimeout(()=>{
                  this.$router.push({ name: "Login" });
                },1000)
              } else {
                this.$message.error(res.data.data)
              }
            });
        } else {
          return false;
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 记住密码
    savePassword() {
      if (document.getElementById("savePassword").checked) {
        var username = this.user.username;
        var password = this.user.password;
        window.sessionStorage.username = username;
        window.sessionStorage.password = password;
        localStorage.rmbPassword = true;
      } else {
        localStorage.rmbPassword = false;
      }
    },
    back(){
      this.$router.push({ name: "Login" });
    }
  },
  watch: {

  },

}
</script>
<style lang="less" scoped>
  /*.login-demo {
    width: 100%;
    height: 100%;
    background-image: url("~@assets/imgs/login-bg.png");
    background-size: cover;
  }*/

  /* 公共样式 */
  /*li {*/
  /*  list-style: none;*/
  /*  float: left;*/
  /*}*/

  .login-demo {
    /*position: fixed;*/
    width: 100%;
    /*height: 100%;*/
    background: url("~@assets/imgs/login-bg.png") no-repeat;
    background-size: cover;
    /*padding-top: 84px;*/
    /*margin: auto;*/
    /*top: 0;*/
    /*left: 0;*/
    /*overflow: hidden;*/
    display: flex;
    /*align-items: center;*/
    justify-content: center;
  }
  .login-wrap {
    display: flex;
    /*width: 680px;*/
    /*width: 60%;*/
    width: 986px;
    height: 96%;
    /*height: 510px;*/
    margin: 0 auto;
    background-color: #ffffff;
    box-shadow: 0 4px 14px 0 rgba(133, 169, 231, 0.51);
    /*border-radius: 0.1rem;*/
    border-radius: 5px;
  }
  .login-left {
    /*width: 3.4rem;*/
    /*height: 3.17rem;*/
    display: flex;
    width: 50%;
    /*height: 317px;*/
    img {
      width: 100%;
    }

  }
  .login-right {
    /*background: url("~@assets/imgs/login-bg.png") no-repeat;*/
    /*width: 3.4rem;*/
    /*height: 3.17rem;*/
    display: flex;
    justify-content: center;
    width: 50%;
    /*height: 317px;*/
    /*margin: 175px auto;*/
    /*margin-left: 272px;*/
    /*border-radius: .06rem;*/
    /*line-height: 20px;*/
    /*padding-top: 0;*/
    .title {
      color: #666;
      font-size: 24px;
      margin-top: 15px;
      margin-bottom: 5px
    }
  }

  .el-tabs .el-tabs__item {
    font-size: 18px;
    margin: 5px auto;
  }

  .el-tabs__nav {
    font-size: 18px;
  }

  a {
    text-decoration: none;
    color: #606266;
    font-size: 14px;
    float: right;
  }

  a:hover {
    color: coral;
  }

  .el-checkbox {
    text-indent: 4px;
  }

  .el-form-item__label {
    /*width: 90px;*/
    text-align: center;
    padding: 0 4px 0 0;
  }
  .el-form-item {
    margin-bottom: 14px;
  }
  .el-checkbox__label {
    padding-left: 0;
  }

  .submit-button {
    margin-top: 10px;
    /*width: 118%;*/
    /*margin-left: -40px;*/
    /*background-color: #16696a;*/
    /*letter-spacing: 5px;*/
    border: 0;
  }

  .register-button /deep/ .el-form-item__content {
    margin-left: 0!important;
  }
  /deep/ .el-input__inner {
    height: 30px;
  }

</style>
